import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Table } from 'semantic-ui-react';

const renderSecondRow = (shape) => {
  let toRender = [];
  shape.forEach((info, key) => {
    const { secondRowRenderFn } = info.header;
    if (secondRowRenderFn && Array.isArray(secondRowRenderFn)) {
      toRender = [...toRender, ...secondRowRenderFn.map((elem, i) => (
        <Table.HeaderCell key={`${key}${i}`}>{elem()}</Table.HeaderCell>))];
    } else if (secondRowRenderFn) {
      toRender = [...toRender, ...secondRowRenderFn()];
    }
  });
  return toRender;
};

const style = { backgroundColor: '#50667F', color: '#FFFFFF' };

const SnukTableHeader = ({
  shape, doubleHeaderRow, editable, doubleRowEditable, t,
}) => (
  <Table.Header>
    <Table.Row verticalAlign="top">
      {editable && <Table.HeaderCell collapsing singleLine style={style} rowSpan={doubleRowEditable ? '2' : '1'} />}
      {Array.from(shape).map(([key, info]) => (
        <Table.HeaderCell
          key={key}
          rowSpan={info.header.doubleRow ? '2' : '1'}
          colSpan={info.header.colSpan || '1'}
          singleLine
          style={style}
        >
          { info.header.title ? t(info.header.title) : '' }
        </Table.HeaderCell>
      ))}
    </Table.Row>
    {doubleHeaderRow
      && (
      <Table.Row>
        {renderSecondRow(shape)}
      </Table.Row>
      )
    }
  </Table.Header>
);

SnukTableHeader.propTypes = {
  shape: PropTypes.shape({}).isRequired,
  doubleHeaderRow: PropTypes.bool,
  doubleRowEditable: PropTypes.bool,
  editable: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

SnukTableHeader.defaultProps = {
  doubleHeaderRow: false,
  doubleRowEditable: false,
};

export default translate()(SnukTableHeader);



// WEBPACK FOOTER //
// ./src/components/reusable/SnukTable/SnukTableHeader.js